module.exports = __webpack_public_path__ + "static/media/pinterest.107e165a.png";